export default "/images/update_to_top.svg?0ef7ce601295d602236132b81e509e18";